import type { ISizes } from "~/components/base/styles";

export interface IWindowSize {
  width: Number | number;
  height: Number | number
};

export default defineNuxtPlugin({
  name: 'window',
  dependsOn: [
    'nuxt:global-components',
    'nuxt:router',
    'nuxt-site-config:init',
  ],
  parallel: true,
  enforce: 'post',
  async setup(nuxtApp: any) {
    const size = ref<IWindowSize>();
    // Window resize
    const handleResize = () => {
      let temp = {
        width: 0,
        height: 0
      };
      temp.width = window.innerWidth;
      temp.height = window.innerHeight;
      size.value = temp;
    };
    const styleSize = computed<ISizes>(() => {
      if ((size?.value?.width >= 1536) && (size?.value?.height >= 1536))
        return '2xl';
      else if ((size?.value?.width >= 1280) && (size?.value?.height >= 1280))
        return 'xl';
      else if ((size?.value?.width >= 1024) && (size?.value?.height >= 1024))
        return 'lg';
      else if ((size?.value?.width >= 768) && (size?.value?.height >= 768))
        return 'md';
      else if ((size?.value?.width >= 640) && (size?.value?.height >= 640))
        return 'sm';
      else return 'none';
    });

    await nuxtApp.vueApp?.use({
      install(app: any, options: any) {
        app.provide('windowSize', size as Ref<IWindowSize>);
        app.provide('styleSize', styleSize as ComputedRef<String | string>);
      },
    });

    nuxtApp.hook('app:mounted', () => {
      if (process?.client) {
        window.addEventListener('resize', handleResize);
        handleResize();
      }
    });

    nuxtApp.hook('app:unmounted', () => {
      if (process?.client)
        window.removeEventListener('resize', handleResize);
    });

    return {
      provide: {
        windowSize: size as Ref<IWindowSize>,
        styleSize: styleSize as ComputedRef<String | string>,
      },
    };
  },
  env: {
    islands: true
  }
});
